import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-bold text-allegra-dark mb-2">Algo salió mal</h2>
            <p className="text-allegra-gray mb-4">Ocurrió un error inesperado.</p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/admin/dashboard';
              }}
              className="px-6 py-2 bg-primary text-white rounded-xl hover:bg-primary/90"
            >
              Volver al Dashboard
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
